import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/users`;

// * Route configuration object for users-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const usersRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:userId`,
  edit: `${baseRoute}/edit/:userId`,
} as const;

// ! these are breadcrumbs translation not page title
const usersRouteTranslation: IRouteTranslation<typeof usersRoutesObj> = {
  list: "usersList",
  create: "addUser",
  edit: "editUser",
  view: "viewUser",
};

// * Extracts the route parameters for the users route configuration.
export type IUsersRouteParams = IExtractRouteParamMap<typeof usersRoutesObj>;

// * Path functions for the users routes.
export const usersPath = createPaths<typeof usersRoutesObj, IUsersRouteParams>(
  usersRoutesObj,
);

// * Breadcrumbs {translation and route} for the users routes
export const usersBreadcrumbs = createBreadcrumbObject<typeof usersRoutesObj>(
  usersRoutesObj,
  usersRouteTranslation,
);
rebase(usersBreadcrumbs, "list");
